<template>
  <ErrorWithCustomMessage v-if="invalidCmr" :code="errorCode" :message="errorMessage"/>
  <LayoutLoggedIn :doneRendering="doneRendering" :accessType="accessType" module="qdrive" v-else>
        <span v-if="doneRendering">
            <span class="cmr" v-if="!invalidCmr">
                <a class="btn btn-primary download-cmr" :download="'cmr-' + cmrNumber + '.pdf'"
                   :href="'data:application/pdf;base64,' + src" target="_blank">Download</a>
                <a class="btn btn-primary print" href="#" @click="printPdf">Print</a>
                 <vue-pdf-embed ref="pdf" v-for="i in pages"
                      :key="i"
                      :page="i"
                      style="display: inline-block; width: 100%;"
                      :source="'data:application/pdf;base64,' + src"></vue-pdf-embed>
            </span>
        </span>
  </LayoutLoggedIn>
</template>

<script>

import QStepApi from '@/libraries/Api/QStep/Api'
import AccessType from '@/components/Core/AccessType'
import LayoutLoggedIn from '@/components/Layout/LoggedIn'
import ErrorWithCustomMessage from '../../Core/LandingPage/ErrorWithCustomMessage'
import PrintJs from 'print-js'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  extends: AccessType,
  components: {
    LayoutLoggedIn,
    ErrorWithCustomMessage,
    VuePdfEmbed,
  },
  props: {
    carItineraryId: {
      type: Number,
      required: true
    },
    encryptedData: {
      type: String
    }
  },
  name: 'Cmr',
  data () {
    return {
      pages: 0,
      src: '',
      invalidCmr: false,
      doneRendering: false,
      cmrNumber: this.carItineraryId,
      errorCode: null,
      errorMessage: null
    }
  },
  mounted () {
    this.loadCmr()
  },
  methods: {
    printPdf (e) {
      PrintJs({ printable: this.src, type: 'pdf', base64: true })
    },
    handleError () {
      this.invalidCmr = true
    },
    loadCmr () {
      this.$showLoadingOverlay()
      const _self = this

      const qStepApi = new QStepApi(this.handleError)
      qStepApi.getPublicCmrEncrypted(this.carItineraryId, this.encryptedData).then(response => {
        if (response.data.data !== undefined) {
          _self.src = response.data.data.pdfStream
          _self.pages = response.data.data.pagesCount
          _self.cmrNumber = response.data.data.cmrNumber
        }
        _self.doneRendering = true
        this.$hideLoadingOverlay()
      }).catch(error => {
        _self.errorCode = error.response.status
        _self.errorMessage = error.response.data.data.messages[0] + ' Please contact email sender for new link.'
        _self.invalidCmr = true
        _self.doneRendering = true
        this.$hideLoadingOverlay()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.print {
  margin-left: 20px;
}

@media print {
  .flex.header, .download-cmr {
    display: none;
  }
}
</style>
